

































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { VueSwiper, SubTitle } from "@/components/index.ts";
import { ConfigModule } from "@/store/index";
import { compatibleImgUrl } from "@/utils/common";

@Component({
  components: {
    VueSwiper,
    SubTitle
  }
})
export default class Home extends Vue {
  /* -------------- data ------------- */
  realIndex = 0; // 当前活动块的索引
  bannerList = []; // banner列表
  productionList = []; // 产品列表
  categoryForGameListTitle = ""; // 游戏列表标题
  ASSETS_URL = process.env.VUE_APP_ASSETS_URL;

  /* -------------- watch ------------- */
  @Watch("lang")
  async onChangeLang (val: string, oldVal: string) {
    if (oldVal) {
      // 清除页面资源
      this.clearAssets();
      // 获取网站资源
      this.initAssets();
    }
  }

  /* -------------- computed ------------- */
  get lang () {
    // 语言key值
    return ConfigModule.lang;
  }

  /* -------------- hook ------------- */
  async created () {
    await this.initAssets();
  }

  /* -------------- methods ------------- */

  /**
   * @description: 兼容图片地址
   */
  compatibleImgUrl (imgUrl: string) {
    return compatibleImgUrl(imgUrl);
  }

  /**
   * @description: 清除页面资源
   */
  clearAssets () {
    this.bannerList = [];
    this.productionList = [];
  }

  /**
   * @description: 初始化页面资源
   */

  async initAssets () {
    try {
      /* 请求网页资源 */
      const getSiteAssetsRet = await ConfigModule.getSiteAssets(this.lang); // eslint-disable-line
      const siteAssets = getSiteAssetsRet.payload.siteAssets.data.asset;

      // 设置banner资源
      if (siteAssets.categoryForCarousel) {
        this.bannerList = siteAssets.categoryForCarousel.items;
        this.updateSwiper();
      }

      // 设置游戏列表标题
      this.categoryForGameListTitle = siteAssets.categoryForGameListTitle;

      // 设置游戏列表
      this.productionList = getSiteAssetsRet.payload.gameList.data.targetList?.filter((item: any) => item.target_name !== "heavenburnsred");
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @description: 向前滚动
   */

  slidePre () {
    (this.$refs.banner as any).slidePre(); // eslint-disable-line
  }

  /**
   * @description: 向后滚动
   */

  slideNext () {
    (this.$refs.banner as any).slideNext(); // eslint-disable-line
  }

  /**
   * @description: 跳转
   */

  slideTo (index: number) {
    (this.$refs.banner as any).slideTo(index); // eslint-disable-line
  }

  /**
   * @description: 更新swiper，每次数据更新调用
   */

  updateSwiper () {
    (this.$refs.banner as any).update(); // eslint-disable-line
    this.realIndex = 0;
  }

  /**
  *  @description: 谷歌分析事件
  */
  gtagHandlle (targetName: string, targetType: string) {
    window.gtag("event", `${targetName}_${targetType}`);
  }

  /**
   * @description: 点击banner触发谷歌分析事件
   */

  gtagBannerHandlle (item: any) {   // eslint-disable-line
    if (item && item.bannerClickUrl) {
      const targetName = item.bannerClickUrl.split("/").pop();
      this.gtagHandlle(targetName, "banner");
    }
  }
}
